import React from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import Skeleton from 'react-loading-skeleton';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
	toggleFlightModal,
	setEtravFlightFare,
} from '../../reducers/UiReducer';
import { setFlightId } from '../../reducers/UiReducer';
import { FlightFareRuleEtravDispatch, fareRuleEtravSuccess,
	fareRuleSuccess, } from '../../reducers/HomeReducer';
import { FlightFareRuleDispatch } from '../../reducers/HomeReducer';

const OneWayMobileRow = ({
	item,
	loading,
	timeConvert,
	location,
	onewayflightdata,
	onewayflightdataEtrav,
	convertH2M,
	net,
}) => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const history = useHistory();
	const dispatch = useDispatch();
	const { orderID } = useSelector((state) => state.home);
	return (
		<>
			<Box
				display='flex'
				style={{
					padding: 8,
				}}
				justifyContent='space-between'
				alignItems='center'
				mt={'20px'}>
				<Box display='flex' alignItems='center'>
					{loading ? (
						<Skeleton variant='circle' width={40} height={40} />
					) : (
						<img
							src={`https://nitish.musafirbazar.com/static/media/${
								item.AirlineCode
									? item.AirlineCode
									: item.Airline_Code
									? item.Airline_Code
									: item.AirlineCode
							}.gif`}
							width='50px'
							height='25px'></img>
					)}

					<Box alignItems='center' ml={'5px'}>
						<TitleText
							two={matches ? false : true}
							textStyle={{
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
								color: '#3c3c3c',
								fontSize: matches ? 12 : '',
							}}>
							{loading ? (
								<Skeleton variant='text' width='60px' />
							) : item.Airline_Code ? (
								item.Segments[0].Airline_Name
							) : (
								item.Segments[0].slice(0, 1).map((i) => {
									return i.Airline.AirlineName;
								})
							)}
						</TitleText>
						{loading ? (
							<Skeleton variant='text' width='60px' />
						) : (
							<BodyText
								three
								textStyle={{
									fontFamily: 'Roboto Serif, sans-serif',
									color: '#8f8f8f',
									fontWeight: 600,
								}}>
								{item.Airline_Code
									? item.Segments[0].Airline_Code
									: item.Segments[0].slice(0, 1).map((i) => {
											return i.Airline.AirlineCode;
									  })}
								-
								{item.Airline_Code
									? item.Segments[0].Flight_Number
									: item.Segments[0].slice(0, 1).map((i) => {
											return i.Airline.FlightNumber;
									  })}
							</BodyText>
						)}
					</Box>
				</Box>

				<Box alignItems='center' display='flex'>
					{loading ? (
						<Skeleton variant='text' width='60px' />
					) : (
						<TitleText
							four={matches ? false : true}
							textStyle={{
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
								fontSize: 18,
							}}>
							{/* ₹{' '}
									{item.Airline_Code
										? Math.round(item.Fares[0].FareDetails[0].Total_Amount)
										: Math.round(item.Fare.PublishedFare)} */}
						</TitleText>
					)}

					{/* <MoreVertIcon /> */}
					{loading ? (
						<Skeleton variant='text' width='60px' height='60px' />
					) : (
						<>
						<Box
							onClick={() => {
								history.push({
									pathname: '/summaryflight',
									state: {
										OneflightData: item,
										body: location.state.body,
										IDTBO:
											onewayflightdata &&
											onewayflightdata.result &&
											onewayflightdata.result.Response &&
											onewayflightdata.result.Response.TraceId,
										IDEtrav:
											onewayflightdataEtrav &&
											onewayflightdataEtrav.result &&
											onewayflightdataEtrav.result.Search_Key,
									},
								});
							}}
							style={{
								color: 'white',
								marginLeft: 5,
								background: 'rgb(239, 51, 57)',
								padding: '8px 25px',
								borderRadius: 8,
								cursor: 'pointer',
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
								boxShadow: '3px 3px 12px -6px rgb(0 0 0 / 70%)',
							}}>
							<TitleText
								textStyle={{
									fontSize: matches ? 14 : '',
								}}>
								₹{' '}
								{item.Airline_Code
								? Number(Math.round(item.Fares.Total_Amount))
								: Number(Math.round(item.Fare.Total_Amount))}
							</TitleText>
							
						</Box>
						{item.Airline_Code ? <span>*</span> : ""}
						</>
						
					)}
				</Box>
			</Box>
			<Box
				display='flex'
				style={{
					boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
					padding: 8,
				}}
				justifyContent='space-between'
				alignItems='center'>
				<Box>
					{loading ? (
						<Skeleton variant='text' width='60px' />
					) : (
						<TitleText
							three
							textStyle={{
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
							}}>
							{item.Origin ? item.Origin : item.FareRules[0].Origin}
						</TitleText>
					)}
					{loading ? (
						<Skeleton variant='text' width='60px' />
					) : (
						<TitleText three>
							{item.Airline_Code
								? item.Segments[0].Departure_DateTime.substr(11, 5)
								: item.Segments[0].slice(0, 1).map((i) => {
										return i.Origin.DepTime.substr(11, 5);
								  })}
						</TitleText>
					)}
				</Box>
				<Box alignItems='center' textAlign='center'>
					{loading ? (
						<Skeleton variant='text' width='100px' />
					) : (
						<BodyText
							two
							textStyle={{
								color: 'rgb(239, 51, 57)',
								fontWeight: 700,
								fontSize: 13,
							}}>
							{timeConvert(
								item.Airline_Code
									? item.Segments.length === 2
										? Number(
												convertH2M(
													item.Segments.filter((i, index) => index === 0).map(
														(it) => it.Duration
													)[0]
												)
										  ) +
										  Number(
												convertH2M(
													item.Segments.filter((i, index) => index === 1).map(
														(it) => it.Duration
													)[0]
												)
										  )
										: item.Segments.length === 1
										? Number(
												convertH2M(
													item.Segments.filter((i, index) => index === 0).map(
														(it) => it.Duration
													)[0]
												)
										  )
										: item.Segments.length === 3
										? Number(
												convertH2M(
													item.Segments.filter((i, index) => index === 0).map(
														(it) => it.Duration
													)[0]
												)
										  ) +
										  Number(
												convertH2M(
													item.Segments.filter((i, index) => index === 1).map(
														(it) => it.Duration
													)[0]
												)
										  ) +
										  Number(
												convertH2M(
													item.Segments.filter((i, index) => index === 2).map(
														(it) => it.Duration
													)[0]
												)
										  )
										: ''
									: item.Segments[0].length == 2
									? Number(
											item.Segments[0]
												.filter((i, index) => index === 0)
												.map((it) => {
													return it.Duration;
												})
									  ) +
									  Number(
											item.Segments[0]
												.filter((i, index) => index === 1)
												.map((it) => {
													return it.Duration;
												})
									  )
									: item.Segments[0].length == 1
									? item.Segments[0].map((i) => i.Duration)
									: item.Segments[0].length == 3
									? Number(
											item.Segments[0]
												.filter((i, index) => index === 0)
												.map((it) => {
													return it.Duration;
												})
									  ) +
									  Number(
											item.Segments[0]
												.filter((i, index) => index === 1)
												.map((it) => {
													return it.Duration;
												})
									  ) +
									  Number(
											item.Segments[0]
												.filter((i, index) => index === 2)
												.map((it) => {
													return it.Duration;
												})
									  )
									: ''
							)}
						</BodyText>
					)}
					{loading ? (
						<Skeleton variant='text' width='60px' />
					) : (
						<BodyText
              two
              textStyle={{
                color: "green",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {item.AirlineCode
                ? item.Segments[0].length === 1
                  ? "Non Stop"
                  : item.Segments[0].length === 2
                  ? "1 Stop"
                  : item.Segments[0].length === 3
                  ? "2 Stop"
                  : ""
                : item.Segments.length === 1
                ? "Non Stop"
                : item.Segments.length === 2
                ? "2 Stop"
                : item.Segments.length === 3
                ? "3 Stop"
                : ""}
            </BodyText>
					)}
				</Box>
				<Box>
					{loading ? (
						<Skeleton variant='text' width='60px' />
					) : (
						<TitleText
							three
							textStyle={{
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
							}}>
							{item.Airline_Code
								? item.Segments.length === 1
									? item.Segments.filter((i, index) => index === 0).map(
											(it) => {
												return it.Destination;
											}
									  )
									: item.Segments.length === 2
									? item.Segments.filter((i, index) => index === 1).map(
											(it) => {
												return it.Destination;
											}
									  )
									: item.Segments.length === 3
									? item.Segments.filter((i, index) => index === 2).map(
											(it) => {
												return it.Destination;
											}
									  )
									: ''
								: item.Segments[0].length == 2
								? item.Segments[0]
										.filter((i, index) => index === 1)
										.map((it) => {
											return it.Destination.Airport.AirportCode;
										})
								: item.Segments[0].length == 3
								? item.Segments[0]
										.filter((i, index) => index === 2)
										.map((it) => {
											return it.Destination.Airport.AirportCode;
										})
								: item.Segments[0].length == 1
								? item.Segments[0].map((it) => {
										return it.Destination.Airport.AirportCode;
								  })
								: ''}
						</TitleText>
					)}
					{loading ? (
						<Skeleton variant='text' width='60px' />
					) : (
						<TitleText three>
							{item.Airline_Code
								? item.Segments.length === 1
									? item.Segments.filter((i, index) => index === 0).map(
											(it) => {
												return it.Arrival_DateTime.substr(11, 5);
											}
									  )
									: item.Segments.length === 2
									? item.Segments.filter((i, index) => index === 1).map(
											(it) => {
												return it.Arrival_DateTime.substr(11, 5);
											}
									  )
									: item.Segments.length === 3
									? item.Segments.filter((i, index) => index === 2).map(
											(it) => {
												return it.Arrival_DateTime.substr(11, 5);
											}
									  )
									: ''
								: item.Segments[0].length == 3
								? item.Segments[0]
										.filter((i, index) => index === 2)
										.map((i) => {
											return i.Destination.ArrTime.substr(11, 5);
										})
								: item.Segments[0].length == 2
								? item.Segments[0]
										.filter((i, index) => index === 1)
										.map((i) => {
											return i.Destination.ArrTime.substr(11, 5);
										})
								: item.Segments[0].length == 1
								? item.Segments[0]
										.filter((i, index) => index === 0)
										.map((i) => {
											return i.Destination.ArrTime.substr(11, 5);
										})
								: ''}
						</TitleText>
					)}
				</Box>
			</Box>
			<Box
        style={{
          padding: "6px 10px",
          background: "#f5f6f6",
          borderBottomLeftRadius: 4,
          borderBottomRightRadius: 4,
          borderTop: "1px solid #e2e2e2",
        }}
        justifyContent="space-between"
        alignItems="center"
        display="flex"
      >
        <Box display="flex" alignItems="center">
          {loading ? (
            <Skeleton variant="text" width="60px" height="40px" />
          ) : (
            <Box
              style={{
                padding: "2px 10px",
                background: item.AirlineCode
                  ? item.FareClassification
                    ? item.FareClassification.Color
                    : ""
                  : "#f56d6d",
                borderRadius: 4,
                boxShadow: "3px 3px 12px -6px rgb(0 0 0 / 70%)",
              }}
            >
              <BodyText
                textStyle={{
                  color: item.AirlineCode
                    ? item.FareClassification
                      ? item.FareClassification.Color === "Blue"
                        ? "white"
                        : "black"
                      : "white"
                    : "white",
                }}
              >
                {item.AirlineCode
                  ? item.FareClassification?.Type
                  : item.Fares.Warning === null || item.Fares.Warning === ""
                  ? item.Fares.FareDetails[0].FareClasses[0].Class_Desc
                  : "MBFARE"}
              </BodyText>
            </Box>
          )}
          {item.Supplier === "TBO" ? (
            item.IsRefundable ? (
              <span
                style={{
                  color: "white",
                  marginLeft: 15,
                  background: "green",
                  padding: "2px 10px",
                  borderRadius: 5,
                  fontSize: 12,
                }}
              >
                R
              </span>
            ) : (
              <span
                style={{
                  color: "white",
                  marginLeft: 15,
                  background: "red",
                  padding: "2px 10px",
                  borderRadius: 5,
                  fontSize: 12,
                }}
              >
                N
              </span>
            )
          ) : item.Fares.Refundable ? (
            <span
              style={{
                color: "white",
                marginLeft: 15,
                background: "green",
                padding: "2px 10px",
                borderRadius: 5,
                fontSize: 12,
              }}
            >
              R
            </span>
          ) : (
            <span
              style={{
                color: "white",
                marginLeft: 15,
                background: "red",
                padding: "2px 10px",
                borderRadius: 5,
                fontSize: 12,
              }}
            >
              N
            </span>
          )}

          {item.Supplier === "TBO" ? (
            item.Fare ? (
              <>
              <i class="fa-light fa-seat-airline"></i>
              <span
                style={{
                  color: "black",
                  marginLeft: 15,
                  background: "yellow",
                  padding: "2px 10px",
                  borderRadius: 5,
                  fontSize: 12,
                }}
              >
                {/* {`${Number(item.Segments[0]
                  .filter((i, index) => index === 0)
                  .map((it) => {
                    return it.NoOfSeatAvailable;
                  })+Number(item.Segments[0]
					.filter((i, index) => index === 1)
					.map((it) => {
					  return it.NoOfSeatAvailable;
					})))} seats avialable`} */}
				{item.Segments[0].filter((i,index)=>index===0).map((it)=>{
						return it.NoOfSeatAvailable
					})}
              </span>
              </>
            ) : (
              // <span
              //   style={{
              //     color: "black",
              //     marginLeft: 15,
              //     background: "yellow",
              //     padding: "2px 10px",
              //     borderRadius: 5,
              //     fontSize: 12,
              //   }}
              // >
              //   Not Available
              // </span>
              <></>
            )
          ) : item.Fares.Seats_Available ? (
            <>
             <i class="fa-light fa-seat-airline"></i>
            <span
              style={{
                color: "black",
                marginLeft: 15,
                background: "yellow",
                padding: "2px 10px",
                borderRadius: 5,
                fontSize: 12,
              }}
            >
            {`${item.Fares.Seats_Available}`}
            </span>
            </>
          ) : (
            // <span
            //   style={{
            //     color: "white",
            //     marginLeft: 15,
            //     background: "red",
            //     padding: "2px 10px",
            //     borderRadius: 5,
            //     fontSize: 12,
            //   }}
            // >
            //   Not Available
            // </span>
            <></>
          )}
        </Box>

        <Box
          onClick={() => {
            dispatch(toggleFlightModal(true));
            dispatch(
              setFlightId(
                item.Airline_Code ? item.Fares.Fare_Id : item.ResultIndex
              )
            );

            if (item.Airline_Code) {
              dispatch(
                FlightFareRuleEtravDispatch(
                  onewayflightdataEtrav &&
                    onewayflightdataEtrav.result &&
                    onewayflightdataEtrav.result.Search_Key,
                  item.Flight_Key,
                  item.Fares.Fare_Id
                )
              );
              dispatch(fareRuleSuccess(null));
            } else {
              dispatch(
                FlightFareRuleDispatch(
                  item.ResultIndex,
                  onewayflightdata &&
                    onewayflightdata.result &&
                    onewayflightdata.result.Response.TraceId
                )
              );
              dispatch(fareRuleEtravSuccess(null));
            }
          }}
          display="flex"
          justifyContent="space-between"
        >
          {/* <Box>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																				fontWeight: 700,
																			}}>
																			Free Meals
																		</BodyText>
																	</Box> */}
          <Box></Box>
          <Box
            display="flex"
            alignItems={"center"}
            style={{ cursor: "pointer" }}
          >
            <p
              textStyle={{
                fontFamily: "Roboto Serif, sans-serif",
                fontSize: 10,
              }}
            >
              Flight Details
            </p>
            <ArrowDropDownIcon />
          </Box>
        </Box>
      </Box>
      <Box>
        <span
          style={{ fontSize: 10, color: "rgb(243 111 17)", fontWeight: 600 }}
        >
          {item.AirlineCode
            ? ""
            : item.Fares.Warning === null || item.Fares.Warning === ""
            ? ""
            : "SPECIAL FARE. IT MAY TAKE 20-30 MINS FOR ISSUANCE. ISSUANCE DEPENDS UPON AVAILABILITY. PASSENGER NAME WILL BE UPDATED 12 TO 24 HOURS PRIOR TO DEPARTURE ON AIRLINE WEBSITE"}
        </span>
      </Box>
		</>
	);
};

export default OneWayMobileRow;
